module.exports = __webpack_public_path__ + "assets/img/block-left-84f9713d.png";